import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ɵConsole } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from 'src/app/components/confirmation-dialog/confirmation-dialog.service';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
//import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import * as XLSX from 'xlsx';
import { ExportgridComponent } from 'src/app/components/grid/exportgrid/exportgrid.component';
import { AddtransferComponent } from './addtransfer/addtransfer.component';
@Component({
  selector: 'app-transfer',
  templateUrl: './transfer.component.html',
  styleUrls: ['./transfer.component.css']
})
export class TransferComponent implements OnInit, AfterViewInit, OnDestroy {


  transferColl: any = [];

  transfertypeColl: any = [];
  filterColl: any = [];

  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;

  istableloading: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Transfer";
  filterstatus: any = "UNPOSTED"

  filtertransfertypeid: number = null;
  filterfromdate: any = new Date();
  filtertodate: any = new Date();
  filtersearchtxt: any = "";

  searchtxt: any = "";
  columnDefs = [
   
    { headerName: 'Transfer No', field: 'transferno' },
    { headerName: 'Date', field: 'transferdate', type: 'date' },
    { headerName: 'Grand Total', field: 'grandtotal',type: 'decimal' },
    { headerName: 'Status', field: 'postingstatus', type: 'activestatus' }, 
  ]

  gridOptions = {
    enableactioncol: true,
    columnDefs: this.columnDefs,
  };

 
 

  constructor(private appService: DhukanDataService, public router: Router, private productFindService: NgbModal, private route: ActivatedRoute, private datePipe: DatePipe,
    private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService, public loginService: LoginDataService) {
    this.fnGetParameterVariable();
    this.fnServiceChanges();

    this.filterfromdate.setDate(this.filterfromdate.getDate() - 15);
  }

  fnGetParameterVariable() {
    this.route.queryParams.subscribe(params => {
      if (params.transfertypeid !== undefined) {
        this.filtertransfertypeid = params.transfertypeid
      }
    })
  }
  //User Check
  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }
    });
  }


  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
         
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    this.fnGetFilterStatus()
  }

  fnCheckPrivilage() {

    this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }



  ngAfterViewInit(): void {
  
  }

  ngOnDestroy(): void {
  
  }


  fnGetFilterStatus() {
    this.filterColl = []    
    this.filterColl.push({ value: 'UNPOSTED', displayname: 'Unposted' });
    this.filterColl.push({ value: 'POSTED', displayname: 'Posted' });
    this.filterColl.push({ value: 'ALL', displayname: 'All' });
    this.filterColl.push({ value: 'CANCELLED', displayname: 'Cancelled' });
  }



  fngetTransferListview() {

    if (this.showProgress) {
      return;
    }

    this.fnShowProgress();
    var data = {
      'transferid': 0,
      'fromdate': this.fnFormatDatetime(this.filterfromdate),
      'todate': this.fnFormatDatetime(this.filtertodate),
      'companyid': this.loginService.fnGetCompanyId(),
      'filterstatus': this.filterstatus       

    }
    this.appService.getTransferByListview(data)
      .subscribe(
        (res) => {

          this.fnHideProgress();
          if (res.json().status == 200) {
            this.transferColl = res.json().result;

            this.fnSetDataTable();
          }
          else if (res.json().status == 400) {
            this.toastr.error('Error', res.json().err_field);
          }


        },
        (err) => {
          this.fnHideProgress();
          this.toastr.error('Error', err);
        })
  }


  fnAddTransfer() {
    try {
      const modalRef = this.productFindService.open(TransferComponent,{ size: <any>'xxl', backdrop: 'static',keyboard: false  });

      modalRef.componentInstance.filtertransfertypeid = this.filtertransfertypeid;
      modalRef.componentInstance.filterfromdate = this.filterfromdate;
      modalRef.componentInstance.filtertodate = this.filtertodate;
      modalRef.componentInstance.ngOnInit();

      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

        this.fngetTransferListview();

      });


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnEditTransfer(pBO) {
    try {
      var deptid = pBO.transferid
      var mode=pBO.modetype
      if (!this.isedit) {
        return;
      }
      const modalRef = this.productFindService.open(AddtransferComponent, { size: <any>'xxl', backdrop: 'static',keyboard: false  });
      modalRef.componentInstance.transferid = deptid;
      modalRef.componentInstance.filtertransfertypeid = this.filtertransfertypeid;
      modalRef.componentInstance.filterfromdate = this.filterfromdate;
      modalRef.componentInstance.filtertodate = this.filtertodate;
      modalRef.componentInstance.formmode = mode;
      modalRef.componentInstance.ngOnInit();
      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

        this.fngetTransferListview();

      });

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }




  public fnDeleteConfirm(pBO) {
    try {
      var deptid = pBO.transferid

      if (!this.isdelete) {
        return;
      }

      
      
      if (pBO.isposted === 1) {
        return;
      }    
      
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete transferustment?')
        .then((confirmed) => {
          if (confirmed) {
            this.fnDeleteTransfer(deptid)
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnDeleteTransfer(deptid) {
    var data = {
      'transferid': deptid,
    }
    this.appService.fnDeleteTransfer(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.toastr.success('', " The transferustment has been deleted successfully.");

            this.fnInsertActivityLog('DELETE', deptid, this.fnGetDescription(deptid));

            this.fngetTransferListview();
          } else {
            this.toastr.error('', res.json().err_field);
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnCurrentRouteChange() {
    var queryParams = {};



    if (this.filtertransfertypeid > 0) {
      queryParams['transfertypeid'] = this.filtertransfertypeid;
    }



    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: queryParams,

      });
  }


  private fnSetDataTable() {
  
  }


  fnPrintData() {
    try {


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnExportData() {
    try {


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

 
  fnGetDescription(id) {
    const index = this.transferColl.findIndex(sku => sku.transferid === id);

    if (index) {
      return this.transferColl[index].transfertypename;
    }
    else {
      return "";
    }

  }
  public fnSearchDatatable(value) {

  

  }
  // //Addtransfer
  fnActionExportClick()  {
    const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
    modalRef.componentInstance.doctype = this.formname;
    modalRef.componentInstance.columnDefs = this.columnDefs;
    modalRef.componentInstance.contentColl = this.transferColl;
    modalRef.componentInstance.fnSetTable();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
    
    });
  }
  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId()       

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res)=>{
        },
        (err)=>{

        });

    } catch {

    }
  }


  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }

  fnMomentDateFormatter(params) {
    if (params.value) {
      return moment(params.value).format('DD-MM-YYYY');//hh:mm a  
    }
    else {
      return '';
    }
  }

  fnMomentDateTimeFormatter(params) {
    if (params.value) {
      return moment(params.value).format('DD-MM-YYYY hh:mm a');//  
    }
    else {
      return '';
    }
  }

  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
